import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { DocmanFileModel } from '../services/docman.model.file';
import { UiService } from '../../../core/services/core.ui.service';

@Component({
  selector: 'file-rename-modal',
  template: require('./file.rename.modal.html')
})
export class FileRenameModalComponent implements OnInit {
  @Input() file: any;

  @Output() onRename = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<any>();

  constructor(
    private docmanFileModel: DocmanFileModel,
    private uiService: UiService
  ) {}

  ngOnInit(): void {
  }

  renameFile(): void {
    let success = false;

    this.docmanFileModel.renameFile(this.file).then(
      () => {
        this.uiService.message.showSuccess(`Renamed file to ${this.file.fileName}`, 'File rename successful');
        this.onRename.emit(this.file);

      },
      () => {
        this.uiService.message.showError(`Error renaming file to ${this.file.fileName}`, 'File rename failed');
        this.onClose.emit();
      }
    );
  }
}
